export function getFormattedDate(inputDate) {
    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(inputDate.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`; // 'MM-DD-YYYY'
}